import { Partner, ShoppingCart } from 'app/api/@generated/backend';

import { EcomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';
import { i18n } from 'app/i18n';
import { getSelectedHouseData } from 'app/data-layers/utils/data-layer-items-utils';
import { HouseType } from 'app/pages/order/model/house-type';

import { pushFunnelEventStep } from './push-funnel-event-step';

export const pushSelectItemToCartEvent = (shoppingCart: ShoppingCart, houseType: HouseType, partner?: Partner) => {
    const items = [getSelectedHouseData(shoppingCart, houseType, partner)];

    pushFunnelEventStep(EcomDataLayerEventType.SELECT_ITEM, partner, items);

    DataLayerUtils.pushEcomEventToDataLayer({
        event: EcomDataLayerEventType.SELECT_ITEM,
        selection_type: i18n.product.name[houseType],
        ecommerce: {
            items,
        },
    });
};
